import Link from "next/link";
import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface IMobileNavLinkProps {
  href: string;
  active: boolean;
  onNavigate: () => void;
  children: ReactNode;
  icon: ReactNode;
}

/**
 * Full-width rail link with left accent for the active route (dashboard + marketing mobile menus).
 */
export function MobileNavLink({
  href,
  active,
  onNavigate,
  children,
  icon,
}: IMobileNavLinkProps): React.ReactElement {
  return (
    <Link
      href={href}
      onClick={onNavigate}
      className={cn(
        "flex w-full items-center gap-3 rounded-r-lg border-l-4 py-2.5 pl-3 pr-2 text-sm transition-colors",
        active
          ? "border-primary bg-primary/12 font-semibold text-primary"
          : "border-transparent text-foreground hover:bg-muted/60"
      )}
    >
      <span className="shrink-0 [&_svg]:h-5 [&_svg]:w-5">{icon}</span>
      <span>{children}</span>
    </Link>
  );
}
